import { FC } from 'react';

import { GiftBrandDeliveryManagePage } from '@service/giftBrand/page/GiftBrandDeliveryManagePage';

// 두 포털은 동일한 배송관리 화면을 사용한다.
// useAuth().giftBrandRole()이 Admin/GiftAgent는 전체 브랜드, 공급사는 담당 브랜드로 구분한다.
export const GiftDeliveryManagementPage: FC = function GiftDeliveryManagementPage() {
  return (
    <div className="min-h-screen bg-gray-50 p-4">
      <GiftBrandDeliveryManagePage />
    </div>
  );
};
